

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { request } from "../../utils/request";
// Insert Payment
export const fetchPrice = createAsyncThunk(
    "posts/fetchPrice",
    async (_, thunkApi) => {
      const { rejectWithValue } = thunkApi;
      try {
        const res = await request.get(`https://ssl.vipwellness-suite.de/api/pricing`);
        return res.data;
      } catch (error) {
        return rejectWithValue(error.response?.data || error.message);
      }
    }
  );
  const initialState = { Pricing: [], Loading: false, erorr: null, reco: [] };
  const CupponSlice = createSlice({
    name:'Price',
    initialState,
    extraReducers:(builder)=>{
        // Insert Payment
    builder.addCase(fetchPrice.pending, (state) => {
        state.Loading = true;
        state.erorr = null;
      });
      builder.addCase(fetchPrice.fulfilled, (state, action) => {
        state.Loading = false;
        state.Pricing = action.payload
      });
      builder.addCase(fetchPrice.rejected, (state, action) => {
        state.Loading = false;
        state.erorr = action.payload;
      });
    }

  })
  export default CupponSlice.reducer